import React from 'react';
import RewindSolid from '@/components/commons/icons/RewindSolid';
import PauseSolid from '@/components/commons/icons/PauseSolid';
import PlaySolid from '@/components/commons/icons/PlaySolid';

const buttonClasses = 'w-full rounded-lg bg-transparent flex items-center justify-center py-2 px-4 my-3 pt-[6px] mr-0';
const iconClasses = 'w-7 h-7 mr-4';

function ModalButtons({
    prevQuestion, pauseTimer, isPaused,
}) {
    return (
        <div className="fixed flex top-4 left-4 z-[10000] text-cirrusWhite cursor-pointer">
            {prevQuestion && (
                <button
                    type="button"
                    data-tooltip-id="tip"
                    title="Previous Question"
                    aria-label="Previous Question"
                    onClick={prevQuestion}
                    className={buttonClasses}
                >
                    <RewindSolid className={iconClasses} />
                </button>
            )}

            <button
                type="button"
                data-tooltip-id="tip"
                title="Pause Game"
                aria-label="Pause Game"
                onClick={() => pauseTimer(!isPaused)}
                className={buttonClasses}
            >
                {!isPaused ? (
                    <PauseSolid className={iconClasses} />
                ) : (
                    <PlaySolid className={iconClasses} />
                )}
            </button>
        </div>
    );
}

export default ModalButtons;
